import React, { Component } from "react";
import { Link } from "react-router-dom";
import buildLink from "../functions/buildlink";
export class SingleThumb extends Component {
  render() {
    return (
      <Link to={buildLink("entrada/" + this.props.slug)}>
        <div className="single-thumb">
          <div className="single-thumb-container">
            <div className="single-thumb-photo">
              <div className="single-thumb-texture" />
              <div
                className="single-thumb-bg"
                style={{ backgroundImage: "url(" + this.props.bg + ")" }}
              />
            </div>
            <div className="single-thumb-info">
              <div className="single-name">{this.props.title}</div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}
SingleThumb.defaultProps = {
  slug: "",
  photo: "",
  edo: "Querétaro",
  title: "2016, año de alternancia y de millonarios desvíos en Quintana Roo"
};



// WEBPACK FOOTER //
// ./src/components/single.js